export default "__VITE_ASSET__Cv0n8ksz__"